import { useEffect } from "react";
import { useAuthStore } from "../stores/auth";
import { useConnectionStore } from "../stores/connection";
import { wsClient } from "../lib/ws-client";
import type { User } from "../types/api";

export function UserSyncEffect() {
  const user = useAuthStore(s => s.user);
  const updateUser = useAuthStore(s => s.updateUser);
  const status = useConnectionStore(s => s.status);

  useEffect(() => {
    if (!user || status !== "connected") return;

    const subId = wsClient.subscribe(
      `users.item.${user.user_id}`,
      (data: unknown) => {
        if (data && typeof data === "object" && "action" in data) {
          const event = data as { action: string; data: User };
          if (event.action === "updated" && event.data) {
            updateUser(event.data);
          }
        }
      }
    );

    return () => {
      wsClient.unsubscribe(subId);
    };
  }, [user, status, updateUser]);

  return null;
}
